<template>
	<div
		id="set-decision-matrix"
		v-if="
			(initialDecisionItems.length > 0 && matrixButtons.length > 0) ||
			displayData
		"
	>
		<initialDecision :isModifiable="true" />
		<decisionMatrix :onMatrixClick="onMatrixClick" />
	</div>
	<div v-else>
		<v-skeleton-loader type="article"></v-skeleton-loader>
		<v-skeleton-loader type="article"></v-skeleton-loader>
	</div>
</template>

<script>
	/**
	 * @fileoverview set-decision-matrix.vue allows the user to set initial decisions and decision matrix.
	 * It relies on vuex to map the state variables from the store files.
	 * 
	 * @components
	 * 		initialDecision - draggable initial decisions list
	 * 		decisionMatrix - 3x3 matrix with friendly fraud on the Y axis and true fraud on the X axis
	 * 
	 * @author Sophia Frankel <sophia.frankel@quavo.com>
	 */
	import initialDecision from "@/components/configuration-explorer/initial-decision.vue";
	import { mapState } from "vuex";

	export default {
		name: "setDecisionMatrix",
		data() {
			return {
				displayData: false,	// display data after a set amount of time
			};
		},
		computed: {
			...mapState({
				matrixButtons: (state) => state.config.decisionMatrix,
				initialDecisionItems: (state) => state.config.initialDecisionItems,
				initialDecisionsValid: (state) =>
					state.config.initialDecisionsValid,
			}),
		},
		methods: {
			/**
			 * Save page if all fields are valid
			 * @param {?Boolean} execute - optional flag for updating the profile.
			 * Defaults to true
			 */
			onSave(execute = true) {
				return new Promise((resolve, reject) => {
					let verdict = false;

					if (this.initialDecisionsValid) {
						verdict = true;
						this.$store.dispatch("updateEvaluationList"); // recreate evaluationList in profile
						this.$store.dispatch("mapMatrixBack");
						if (execute) {
							this.$store.dispatch("updateProfile");
						}
					} else {
						const notification = {
							status: "error",
							message: "Fix missing or invalid settings before saving.",
						};
						this.$store.dispatch(
							"notifications/addNotification",
							notification
						);
					}
					if (verdict) {
						resolve();
					} else {
						reject("Failed validation");
					}
				});
			},
			/**
			 * Update matrix button status
			 * @param {Number} id - matrix button id 
			 */
			onMatrixClick(id) {
				let status = this.matrixButtons[id].decision;
				this.matrixButtons[id].decision =
					status === "Refer"
						? "Deny"
						: status === "Deny"
						? "Pay"
						: "Refer";

				this.setProfileChanged();
			},
			/**
			 * Set profile changed flag in the config store
			 */
			setProfileChanged() {
				this.$store.dispatch("setProfileChanged", true);
			},
		},
		components: {
			initialDecision,
			decisionMatrix: () =>
				import("@/components/configuration-explorer/decision-matrix.vue"),
		},
		/**
		 * Mounted lifecycle hook
		 * Set display data to true after 2 seconds
		 */
		mounted() {
			this.timeout = setTimeout(() => (this.displayData = true), 2000);
		},
	};
</script>

<!-- Styles defined in _setDecisionMatrix.scss -->
